import { FC, useState } from 'react';
import {
  NudosButton,
  NudosGenericModal,
  NudosModalContent,
  NudosTextInput
} from '../../../../components/NudosComponents';
import { IconWarning } from '../../../../assets/DesignSystem/SVGComponents';
import { IpillsByReference } from '../../../../types/orders';
import { EXCLUDE_PILL } from '../../../../types/pills';
import './NewEditSkuModal.scss';

interface IEditSkuModal {
  closeModal: () => void;
  defaultSku: string;
  loadingSku: boolean;
  updateSKU: (newSku: string) => void;
  notFoundSku: boolean;
  handleChangeFoundSku: (error: boolean) => void;
  productInfo?: {
    name?: string;
    units?: number;
    pills?: IpillsByReference | null;
  };
}

const NewEditSkuModal: FC<IEditSkuModal> = ({
  closeModal,
  defaultSku,
  updateSKU,
  loadingSku,
  notFoundSku,
  handleChangeFoundSku,
  productInfo
}: IEditSkuModal) => {
  return (
    <NudosGenericModal
      closeModalCallback={() => {
        closeModal();
      }}
      clickOutsideCallback={() => {
        closeModal();
      }}
      modalContent={
        <NudosModalContent
          customWidth="580px"
          customHeight="446px"
          modalContentTitle="Cambio de SKU"
          customHeaderClass="pl-32"
          startHeader
          toCloseModal={() => {
            closeModal();
          }}
          CustomModalComponent={
            <NewSkuModal
              defaultSku={defaultSku}
              closeModal={closeModal}
              updateSKU={updateSKU}
              loadingSku={loadingSku}
              notFoundSku={notFoundSku}
              handleChangeFoundSku={handleChangeFoundSku}
              productInfo={productInfo}
            />
          }
        />
      }
    />
  );
};

export default NewEditSkuModal;

const NewSkuModal: FC<IEditSkuModal> = ({
  defaultSku,
  updateSKU,
  loadingSku,
  notFoundSku,
  handleChangeFoundSku,
  productInfo = {
    name: 'Mac book pro 14',
    units: 10
  }
}: IEditSkuModal) => {
  const [newSku, setNewSku] = useState<string>();
  const profileAndLinePills = Object.values(EXCLUDE_PILL) as EXCLUDE_PILL[];
  const pillsEntries = Object.entries(productInfo?.pills || {})
    .filter(([key, value]) => value && key && !profileAndLinePills.includes(key as EXCLUDE_PILL))
    .slice(0, 3)
    .map(([key, value]) => value)
    .join(' - ');

  return (
    <div id="newEditSkuModal">
      <div className="title">El SKU hace referencia a que producto o modelo es </div>
      <div className="alertMessage">
        <IconWarning />
        <span className="alertMessageText">Para editar el SKU, el SKU nuevo debe estar creado en catálogo </span>
      </div>
      <div className="productInfoContainer">
        <span className="productItem">{productInfo.name} </span>
        <span className="productItem">{`- ${pillsEntries}`}</span>
        <span className="productLastItem">{`${productInfo.units} unidades`}</span>
      </div>
      <div className="defaultSKU">
        <NudosTextInput
          defaultValue={defaultSku}
          styleLabel="modalLabel"
          label="SKU actual "
          isDeactivated
          isFilled
          placeholder=""
        />
      </div>
      <div className="newSKU">
        <NudosTextInput
          handleChange={e => {
            setNewSku(e);
            handleChangeFoundSku(false);
          }}
          styleLabel="modalLabel"
          label="SKU nuevo"
          isFilled={!!newSku}
          placeholder="Escribe el SKU"
          errorText={notFoundSku ? 'Este SKU no existe en el catalogo' : ''}
        />
      </div>
      <div className="buttonModal">
        <NudosButton
          isButtonLoading={loadingSku}
          buttonText="Guardar"
          isButtonDisabled={!newSku || loadingSku || notFoundSku}
          handleClick={() => {
            updateSKU(newSku?.trim() || '');
          }}
          customWidth="380px"
          customHeight="38px"
        />
      </div>
    </div>
  );
};
